import React, { useState, useEffect } from "react";
import Slider from "react-slick";

export default function HowCanYouEarn() {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [activeId, setActiveId] = useState(0);
  let slider1, slider2;

  // Updated "How Can You Earn?" content
  const earnContents = [
    {
      title: "Web-link based integration",
      description: `This method allows you to add our game centre inside your app or site.
After you sign up to be a partner, we send you a custom Gamezop weblink with your unique ID (e.g. gamezop.com/?id=YourPublisherID), which opens our game centre.
Place our icon or banner within your product; you will get recommendations for placements from a Gamezop account manager.
When your users click on this icon / banner, open your custom Gamezop weblink on a Chrome Custom Tab or iframe.
Using the unique ID in the weblink that we provide you, we track the ad revenue generated by your users on our game centre; this revenue is then shared with you.`,
    },
    {
      title: "API Integration",
      description: `This method allows you to handpick individual games from our game centre for your product.
After you sign up to be a partner, we send you a simple API doc to facilitate the integration.
The API has metadata for each game in our game centre: game name, creative assets, and weblinks, etc.
Using the API, place any number of our games in your app or site; this allows you to blend games with the rest of your product.
Using a unique ID in the API endpoint we provide you, we track the ad revenue generated by your users on our games; this revenue is then shared with you.`,
    },
    {
      title: "Web-link based integration",
      description: `This method allows you to add our game centre inside your app or site.
After you sign up to be a partner, we send you a custom Gamezop weblink with your unique ID (e.g. gamezop.com/?id=YourPublisherID), which opens our game centre.
Place our icon or banner within your product; you will get recommendations for placements from a Gamezop account manager.
When your users click on this icon / banner, open your custom Gamezop weblink on a Chrome Custom Tab or iframe.
Using the unique ID in the weblink that we provide you, we track the ad revenue generated by your users on our game centre; this revenue is then shared with you.`,
    },
  ];

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  }, [slider1, slider2]);

  return (
    <section className="released-games-area gray-bg pt-115 pb-70">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-10">
            <div className="section-title title-style-three text-center mb-20">
              <h2>
                How Can You <span>Earn?</span>
              </h2>
              <p>
                Choose the integration method that fits your app or website to
                monetize with our game centre.
              </p>
            </div>
          </div>
        </div>

        <div className="row align-items-center">
          {/* Main slider */}
          <div className="col-xl-8 col-lg-12">
            <Slider
              className="released-game-active"
              asNavFor={nav2}
              ref={(slider) => (slider1 = slider)}
              arrows={false}
            >
              {earnContents.map((item, i) => (
                <div key={i} className="released-game-carousel overflow-hidden">
                  <div className="released-game-item">
                    <div className="released-game-item-bg" />
                    <div className="released-game-content">
                      <h4>{item.title}</h4>
                      <p style={{ whiteSpace: "pre-line" }}>
                        {item.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          {/* Navigation slider */}
          <div className="col-xl-4 col-lg-12">
            <Slider
              className="released-game-nav"
              asNavFor={nav1}
              swipeToSlide={true}
              focusOnSelect={true}
              ref={(slider) => (slider2 = slider)}
              slidesToShow={2} // reduced to fit 2 items if text is long
              vertical={true}
              arrows={false}
            >
              {earnContents.map((item, i) => (
                <div
                  key={i}
                  onClick={() => setActiveId(i)}
                  className={`released-game-nav-item p-4 text-black bg-white ${
                    activeId === i ? "bg-danger-dark" : "dark"
                  }`}
                >
                  <h5 className="text-black">{item.title}</h5>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
}
